<template>
  <div id="washingMachineSetting">
    <!-- 弹窗 -->
    <el-dialog
      v-model="dialogVisible"
      :title="`${form.cid ? '编辑' : '添加'}厂商配置`"
      :width="$store.state.screenWidth > 1200 ? '800px' : '98%'"
      align-center
      @closed="dialogClosed"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="formRef" :rules="rules">
        <el-form-item label="类型名称" label-width="120px" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入类型名称"
            clearable
            disabled
          />
        </el-form-item>
        <el-form-item
          v-for="item in form.settings"
          :key="item.itemKey"
          :label="item.itemName"
          label-width="120px"
        >
          <el-input
            v-model="item.itemValue"
            :placeholder="`请输入${item.itemName}`"
            clearable
          />
        </el-form-item>
        <el-form-item label="状态" label-width="120px" prop="state">
          <el-switch
            v-model="form.state"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item label="备注" label-width="120px" prop="remark">
          <el-input
            v-model="form.remark"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            maxlength="30"
            show-word-limit
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="dialogSubmit(formRef)"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
    <div
      class="head"
      v-if="!data.id"
      v-grantShow="$store.state.SysGrant.GetAllWashSettings"
    >
      <div class="head_left"></div>
      <div class="head_right">
        <el-select
          v-model="selectId2"
          placeholder="请选择"
          style="width: 120px"
        >
          <el-option
            v-for="(item, index) in selectData2"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input
          v-model="washingMachineSettingData_req.value"
          placeholder="请输入关键词"
          class="input-with-select"
          :clearable="true"
          @clear="washingMachineSettingGet"
          @keydown.enter="washingMachineSettingGet"
          :disabled="selectId2 == 2"
        >
          <template #append>
            <el-button icon="Search" @click="washingMachineSettingGet" />
          </template>
          <template #prepend>
            <el-select
              v-model="selectId"
              placeholder="请选择"
              style="width: 120px"
            >
              <el-option
                v-for="(item, index) in selectData"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-input>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      ref="multipleTable"
      :data="washingMachineSettingData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#F4F7FB' }"
      :header-row-style="{
        backgroundColor: '#F4F7FB',
        color: '#1E2026',
      }"
    >
      <el-table-column prop="cid" label="厂商ID" min-width="80">
      </el-table-column>
      <el-table-column prop="name" label="厂商名称" min-width="100">
      </el-table-column>
      <el-table-column prop="data" label="配置类型" min-width="110">
        <template #default="scope">
          <el-tag :type="scope.row.data.uid ? 'success' : 'primary'">
            {{
              data.id
                ? "厂商配置"
                : scope.row.data.uid
                ? `个人配置-${scope.row.data.uid}`
                : "全局配置"
            }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="厂商配置" min-width="300">
        <template #default="scope">
          <div
            class="text"
            v-for="item in settingsTranslate(scope.row)"
            :key="item.itemKey"
          >
            {{ item.itemName }}：{{ item.itemValue || "--" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="备注" min-width="150" show-overflow-tooltip>
        <template #default="scope">
          <div v-if="scope.row.data && scope.row.data.settings">
            {{ scope.row.data.remark || "--" }}
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="80">
        <template #default="scope">
          <div v-if="scope.row.data && scope.row.data.settings">
            <el-switch
              v-model="scope.row.data.state"
              :active-value="1"
              :inactive-value="0"
              @change="stateChange(scope.row)"
            />
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :width="$store.state.screenWidth > 1200 ? 100 : 60"
        :fixed="$store.state.screenWidth > 1200 ? 'right' : 'right' || false"
      >
        <template #default="scope">
          <el-button
            link
            type="primary"
            @click="washingMachineSettingEditor(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { reactive, ref, getCurrentInstance, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "element-plus";
//父组件传递数据
let props = defineProps({
  drawer: Boolean,
  data: {
    type: Object,
    default: {},
  },
});
//获取公共方法
let { proxy } = getCurrentInstance();
//全局数据
let vuex = useStore();
//表单对象
let formRef = ref(null);
//洗衣机对接配置表单数据
let form = reactive({
  cid: 1,
  uid: undefined,
  name: "",
  settings: [],
  state: 1,
  remark: "",
});
//form表单字典
let formMap = reactive({
  1: [
    // {
    //   itemKey: "host",
    //   itemType: "input",
    //   itemName: "接口地址",
    //   itemValue: "",
    // },
    {
      itemKey: "service_id",
      itemType: "input",
      itemName: "服务ID",
      itemValue: "",
    },
    {
      itemKey: "service_key",
      itemType: "input",
      itemName: "服务Key",
      itemValue: "",
    },
    {
      itemKey: "api_key",
      itemType: "input",
      itemName: "API Key",
      itemValue: "",
    },
  ],
  2: [
    {
      itemKey: "api_id",
      itemType: "input",
      itemName: "API ID",
      itemValue: "",
    },
    {
      itemKey: "api_secret",
      itemType: "input",
      itemName: "API SECRET",
      itemValue: "",
    },
  ],
  3: [
    {
      itemKey: "store_id",
      itemType: "input",
      itemName: "洗衣点编码",
      itemValue: "",
    }
  ],
  4: [
    {
      itemKey: "api_key",
      itemType: "input",
      itemName: "API Key",
      itemValue: "",
    },
    {
      itemKey: "api_secret",
      itemType: "input",
      itemName: "API SECRET",
      itemValue: "",
    },
    {
      itemKey: "merchant_id",
      itemType: "input",
      itemName: "商户ID",
      itemValue: "",
    },
  ],
  5: [
    {
      itemKey: "app_id",
      itemType: "input",
      itemName: "APP ID",
      itemValue: "",
    },
    {
      itemKey: "app_secret",
      itemType: "input",
      itemName: "APP Secret",
      itemValue: "",
    },
    {
      itemKey: "store_id",
      itemType: "input",
      itemName: "Store ID",
      itemValue: "",
    },
  ],
  6: [
    {
      itemKey: "service_id",
      itemType: "input",
      itemName: "服务ID",
      itemValue: "",
    },
    {
      itemKey: "service_key",
      itemType: "input",
      itemName: "服务Key",
      itemValue: "",
    },
    {
      itemKey: "api_key",
      itemType: "input",
      itemName: "API Key",
      itemValue: "",
    },
    {
      itemKey: "store_id",
      itemType: "input",
      itemName: "Store ID",
      itemValue: "",
    },
  ],
});
//校验规则
let rules = reactive({
  name: [
    { required: true, message: "洗衣机对接配置名称不能为空", trigger: "blur" },
  ],
  state: [{ required: true, message: "请选择状态", trigger: "blur" }],
});
//搜索条件
let selectId = ref(1);
//搜索下拉数据
let selectData = reactive({
  1: {
    label: "门店代码",
    value: 1,
    key: "hotel_code",
  },
});
//筛选配置类型下拉数据下标
let selectId2 = ref(1);
//筛选配置类型下拉数据
let selectData2 = reactive({
  1: {
    label: "个人配置",
    value: 1,
  },
  2: {
    label: "全局配置",
    value: 2,
  },
});
//洗衣机对接配置请求数据
let washingMachineSettingData_req = reactive({
  value: "",
});
//洗衣机对接配置数据
let washingMachineSettingData = ref([]);
//编辑/添加洗衣机对接配置弹窗状态
let dialogVisible = ref(false);
//监听请求参数变化事件
watch([() => selectId2.value], async (newValue, oldValue) => {
  washingMachineSettingGet();
});
//页面渲染事件
onMounted(() => {
  if (props.data.id) {
    //酒店内集团客户也要填写store_id
    formMap[1].push({
      itemKey: "store_id",
      itemType: "input",
      itemName: "Store ID",
      itemValue: "",
    });
  }
  washingMachineSettingGet();
});
//洗衣机对接配置获取
function washingMachineSettingGet() {
  let grants = proxy.$dataConver.checkGrants(
    vuex.state.userInfo.grants,
    vuex.state.SysGrant.GetAllWashSettings
  );
  let req = {};
  req[selectData[selectId.value].key] = washingMachineSettingData_req.value;
  if (props.data.id) req.hotel_id = props.data.id;
  if (selectId2.value == 2) req.uid = 0;
  proxy.$http
    .get(
      `webapi/${props.data.id ? "hotel_" : ""}wash_settings_mgr?item=companys`,
      {
        params: {
          ...req,
          // uid: grants?0:undefined,
          // uid: selectId2.value == 2 ? 0 : undefined,
        },
      }
    )
    .then(({ data: res }) => {
      if (res.code == 0) {
        washingMachineSettingData.value = res.data;
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//编辑洗衣机对接配置
function washingMachineSettingEditor(obj, show = true) {
  form.cid = obj.cid;
  form.name = obj.name;
  let settingsValue = {};
  if (obj.data) {
    form.state = obj.data.state;
    form.uid = obj.data.uid || undefined;
    form.remark = obj.data.remark;
  }
  if (obj.data.settings) settingsValue = obj.data.settings;
  (formMap[obj.cid] || []).forEach((item) => {
    item.itemValue = settingsValue[item.itemKey] || "";
  });
  form.settings = formMap[obj.cid];
  console.log(form);
  dialogVisible.value = show;
}
//配置翻译
function settingsTranslate(obj) {
  let settingsMap = proxy.$dataConver.deepClone(formMap[obj.cid] || []);
  let settingsValue = {};
  if (obj.data && obj.data.settings) settingsValue = obj.data.settings;
  settingsMap.forEach((item) => {
    item.itemValue = settingsValue[item.itemKey];
  });
  return settingsMap;
}
//表格内状态变换事件
function stateChange(obj) {
  washingMachineSettingEditor(obj, false);
  dialogSubmit(formRef.value);
}
//弹窗确认事件
function dialogSubmit(formEl) {
  let grants = proxy.$dataConver.checkGrants(
    vuex.state.userInfo.grants,
    vuex.state.SysGrant.GetAllWashSettings
  );
  let req = {
    // uid: grants?0:undefined,
    hotel_id: props.data.id,
    uid: form.uid,
    cid: form.cid,
    state: form.state,
    settings: {},
    remark: form.remark,
  };
  form.settings.forEach((item) => {
    if (item.itemValue) req.settings[item.itemKey] = item.itemValue;
  });
  req.settings = JSON.stringify(req.settings);
  proxy.$http
    .post(`webapi/${props.data.id ? "hotel_" : ""}wash_settings_mgr?item=set`, {
      ...req,
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        ElMessage({
          message: `${form.cid ? "编辑" : "添加"}成功！`,
          type: "success",
        });
        dialogVisible.value = false;
        washingMachineSettingGet();
      } else {
        ElMessage({
          message: `${form.cid ? "编辑" : "添加"}失败！`,
          type: "error",
        });
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//弹窗关闭事件
function dialogClosed() {
  formRef.value.resetFields();
  form.cid = 1;
  form.uid = undefined;
  form.name = "";
  form.state = 1;
  form.remark = "";
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/washingMachine/washingMachineSetting.scss";
</style>